import styled from '@emotion/styled';

export const InfoInput = styled.input`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  padding: 0px 8px;
  line-height: 24px;
  border-radius: 4px;
  outline: none;
  box-shadow: none;
  border: 1px solid #ccc;
`;

export const InfoItem = styled.div`
  margin-bottom: 8px;
  font-size: 16px;
`;
